import { render, staticRenderFns } from "./taskEdit.vue?vue&type=template&id=f4d1a664&scoped=true&"
import script from "./taskEdit.vue?vue&type=script&lang=tsx&"
export * from "./taskEdit.vue?vue&type=script&lang=tsx&"
import style0 from "./taskEdit.vue?vue&type=style&index=0&id=f4d1a664&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d1a664",
  null
  
)

export default component.exports